import { colors } from '../../theme';

const styles = {
  // The page never scrolls: the swipe moves the videos. Pinned to the visible screen, not to a height
  // measured in JS: on iOS that one is sometimes wrong at load and the footer ends up under the toolbar.
  feed: {
    position: 'fixed',
    inset: 0,
    overflow: 'hidden',
    overscrollBehavior: 'contain',
    // The swipe is ours alone: otherwise Safari first tries its own scroll and holds the finger back.
    touchAction: 'none',
    backgroundColor: colors.background,
  },
  fullHeight: {
    height: '100%',
  },
  // Each slide on its own layer: a video mounted in the next slide no longer repaints the one on
  // screen (its footer and actions flashed right after a swipe).
  slide: {
    height: '100%',
    overflow: 'hidden',
    contain: 'strict',
    willChange: 'transform',
  },
  mute: {
    position: 'absolute',
    top: '4.1rem',
    right: '0.8rem',
    zIndex: 12,
    color: colors.text,
    fontSize: 22,
    filter: 'drop-shadow(0 1px 2px rgba(0, 0, 0, 0.55))',
  },
};

export default styles;
